import { render } from "./commonCompanies.vue?vue&type=template&id=b6f8f8bc"
import script from "./commonCompanies.vue?vue&type=script&lang=js"
export * from "./commonCompanies.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__